export default __webpack_public_path__ + "static/media/instagram.1cad6658.svg";